module.exports = __webpack_public_path__ + "images/0faf6820be5dbc172218847a15fe2b29.png";